(function () {

    'use strict';

    if (typeof window === 'undefined') {

        module.exports = exportFn(
            require('../../../enums/metrics.js').dataType,
            require('../../../enums/metrics.js').collection,
            require('../../../enums/metrics.js').sources,
            require('../../../enums/metrics.js').sourceDetails,
            require('../enums/dataSourceFilterGroupIds.js')
        );

    } else {
        RivalIQ.module('metrics.new.dataSources', function (dataSources) {
            dataSources.CrossChannelInsightsPost = exportFn(
                RivalIQ.enums.dataType,
                RivalIQ.enums.collection,
                RivalIQ.enums.sources,
                RivalIQ.enums.sourceDetails,
                RivalIQ.metrics.new.enums.DataSourceFilterGroupIds
            );
        });
    }

    function exportFn(dataType, collection, sources, sourceDetails, DataSourceFilterGroupIds) {
        return {
            name: 'Cross-Channel Insights post data',
            channelName: sourceDetails[sources.CROSS_CHANNEL_INSIGHTS].name,
            postName: sourceDetails[sources.CROSS_CHANNEL_INSIGHTS].postName,

            storageDimensions: [
                'post_id'
            ],

            availableDimensions: [
                'companyId',
                'companySetId',
                'day',
                'dayOfWeek', 'hourOfDay',
                'postTagId',
                'hashtag',
                'keyword'
            ],

            fields: {
                post_id: {
                    dataType: dataType.STRING
                },
                source: {
                    dataType: dataType.INTEGER
                },
                native_id: {
                    dataType: dataType.STRING
                },
                company_id: {
                    dataType: dataType.STRING
                },
                company_name: {
                    dataType: dataType.STRING
                },
                presence_icon_url: {
                    dataType: dataType.STRING
                },
                published_at: {
                    dataType: dataType.DATE
                },
                captured_at: {
                    dataType: dataType.DATE
                },
                message: {
                    dataType: dataType.STRING
                },
                media_type: {
                    dataType: dataType.STRING
                },
                video_views: {
                    dataType: dataType.INTEGER
                }
            },

            supportedFilterGroups: [
                DataSourceFilterGroupIds.company,
                DataSourceFilterGroupIds.timePeriod,
                DataSourceFilterGroupIds.source,
                DataSourceFilterGroupIds.publicPost, // TODO: rename publicPost into just post
                DataSourceFilterGroupIds.ordering
            ]
        };
    }
})();
